import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Notifications from "@material-ui/icons/Notifications";
import HotTubIcon from "@material-ui/icons/HotTub";
// core components/views for Admin layout
import UserProfile from "../views/UserProfile/UserProfile.js";
import AddProduct from "../views/Product/AddProduct.js";
import Products from "../views/Product/ProductTable.js";
import ProductEdit from "../views/Product/ProductEdit.js";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { getVendorDetails } from "../store/actions/vendor/Vendor";

import Maps from "../views/Maps/Maps.js";
// core components
import Navbar from "../components/Navbars/Navbar.js";
import Footer from "../components/Footer/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";

import routes2 from "../routes2.js";

import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/logo.png";
import ListAltIcon from "@material-ui/icons/ListAlt";

let ps;

const switchRoutes = (
  <Switch>
    {routes2.map((prop, key) => {
      if (prop.layout === "/vendor") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })}
  </Switch>
);

const useStyles = makeStyles(styles);

function Vendor({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const image = bgImage;
  const color = "blue";
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const valueUserLoginType = localStorage.getItem("userLoginType") || "";
  const vendorSuperCategory = localStorage.getItem("vendorSuperCategoryId");

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  useEffect(() => {
    rest.getVendorDetails();
  }, []);

  return (
    <div className={classes.wrapper}>
      {valueUserLoginType !== "vendor" ? (window.location.href = "/") : ""}
      <Sidebar
        routes={routes2}
        logoText={"TravelPick Vendor"}
        logo={logo}
        image={image}
        style={{ textDecoration: "none" }}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes2}
          style={{ textDecoration: "none", backgroundColor: "#FFF" }}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content} style={{ textDecoration: "none" }}>
            <div
              style={{ textDecoration: "none" }}
              className={classes.container}
            >
              {switchRoutes}
              <Switch>
                <Route
                  exact="true"
                  path="/vendor/user"
                  component={UserProfile}
                />

                <Route
                  exact="true"
                  path="/vendor/products"
                  component={Products}
                />
                <Route
                  exact="true"
                  path="/vendor/add-product"
                  component={AddProduct}
                />
                <Route
                  exact="true"
                  path="/vendor/product-edit/:productId"
                  component={ProductEdit}
                />

                <Route
                  exact="true"
                  path="/vendor/user/details/:id"
                  component={UserProfile}
                />
                <Route exact="true" path="/vendor/maps" component={Maps} />

                <Redirect exact path="/vendor" to="/vendor/dashboard" />
              </Switch>
            </div>
          </div>
        ) : (
          <div className={classes.map} style={{ textDecoration: "none" }}></div>
        )}
        {/* {getRoute() ? <Footer /> : null} */}
      </div>
    </div>
  );
}

const mapStateWithProps = (state) => ({
  vendorDetails: state.vendor.vendorDetails,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getVendorDetails: () => dispatch(getVendorDetails()),
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(Vendor);
